import { render, staticRenderFns } from "./Content01.vue?vue&type=template&id=f6460778&scoped=true"
import script from "./Content01.vue?vue&type=script&lang=js"
export * from "./Content01.vue?vue&type=script&lang=js"
import style0 from "./Content01.vue?vue&type=style&index=0&id=f6460778&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6460778",
  null
  
)

export default component.exports